import script from "./WebinarListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebinarListItem.vue?vue&type=script&lang=ts&setup=true"

import "./WebinarListItem.vue?vue&type=style&index=0&id=69f78dd9&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69f78dd9"]])

export default __exports__